import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import {
  RescuePlacementModel,
  useRescuePlacementNavigator,
  RedirectToRescuePlacementHome,
  transferringOwnershipTitle,
} from '../rescuePlacementUtils';
import GoBackLink from '../components/GoBackLink/GoBackLink';
import PetView from '../PetView/PetView';
import styles from './PetPlacement.module.scss';

export default function PetPlacement({ model, petId }: { model: RescuePlacementModel; petId: string }) {
  const { t } = useTranslation();
  const navigator = useRescuePlacementNavigator();

  const pet = model.getPetById(petId);

  if (!pet) {
    return <RedirectToRescuePlacementHome />;
  }

  const disableTransferToAdopter = pet.device?.currentCollarModel !== 'S2';

  return (
    <div className={styles.main}>
      <GoBackLink />
      <PetView pet={pet} title={transferringOwnershipTitle(pet, t)} />
      <Button onClick={() => navigator.go({ placementView: 'petTemporaryPlacement', petId })}>
        {t('transfer_to_a_foster_parent')}
      </Button>
      <Button
        disabled={disableTransferToAdopter}
        onClick={() => navigator.go({ placementView: 'petPermanentPlacement', petId })}
      >
        {t('transfer_to_an_adopter_button')}
      </Button>
      {disableTransferToAdopter ? <p>{t('transfers_to_adopters_are_no_longer_supported')}</p> : <></>}
    </div>
  );
}
